import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import MBFLogo from '../../utilities/dummy_assets/MBF_Logo.png';
import MapITLogo from '../../utilities/dummy_assets/mapITlogo.png';
import postureImage from '../../utilities/dummy_assets/image24.png';
import sizeImage from '../../utilities/dummy_assets/image25.png';
import background from '../../utilities/dummy_assets/background.png';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import tinkerersLogo from '../../utilities/dummy_assets/tinkerersLogo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';
import Logos from '../../components/logos';
import { toast } from 'react-toastify';

const RegisterInstructions = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);
  const handleOpenCamera = async () => {
    if (!isChecked) {
      setShowError(true);
      return;
    }

    try {
      // Try to access the user's camera
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      // Stop the camera immediately after checking permission
      stream.getTracks().forEach(track => track.stop());

      // Proceed to the profile capture page
      navigate('/profile-capture');
    } catch (err) {
      // Show user-friendly error
      toast.error(
        'Camera access denied. Please allow camera permission to proceed.'
      );
    }
  };

  return (
    <Box
      sx={{
        // width: "100vw",
        minHeight: '100vh',
        overflow: 'hidden',
        display: 'flex',
        // alignItems: {sm: "center"},
        // background: { xs: 'white', sm: `url(${background})` },
        backgroundImage: { sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: '0.5rem',
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Top Left Logo */}
      {/* <Box sx={{ position: "absolute", top: 20, left: 20 }}>
        <img src={MBFLogo} alt="MBF Logo" style={{ maxWidth: "120px", height: "auto" }} />
      </Box> */}

      {/* Top Right Link */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          p: '16px 12px',
        }}
      >
        <span
          onClick={() =>
            (window.location.href = 'https://tinkerspace.mis.mapit.ai/login')
          }
          style={{
            color: 'var(--Accent-Accent-01, #0062CC)',
            cursor: 'pointer',
            textDecoration: 'underline',
            fontSize: { xs: '12px', sm: '16px' },
          }}
        >
          Go to Student Site
        </span>
      </Box>

      {/* Main Card */}
      <Box
        sx={{
          width: '100%',
          maxWidth: '520px',
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          padding: { sm: '20px 20px' },
          boxShadow: { sm: '4px 4px 20px rgba(0, 123, 255, 0.1)' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          margin: 'auto',
          gap: '20px',
        }}
      >
        {/* Title */}
        <Typography
          variant="h5"
          fontWeight={600}
          color="#212121"
          align="center"
          sx={{ mb: 1 }}
        >
          Set Your Profile Photo
        </Typography>

        {/* Note */}
        <Box
          sx={{
            width: '100%',
            backgroundColor: '#FEFFD2',
            borderLeft: '4px solid #D0A300',
            borderRadius: '4px',
            padding: { sm: '10px 12px' },
            textAlign: 'center',
          }}
        >
          <Typography fontSize="14px" fontWeight={500} color="#D0A300">
            Keep these things in mind while clicking your picture
          </Typography>
        </Box>

        {/* Posture Section */}
        <Box sx={{ width: '100%' }}>
          <Typography fontWeight={500} fontSize="16px" color="#3F3F3F" mb={1}>
            Posture:
          </Typography>
          <img
            src={postureImage}
            alt="Posture"
            style={{ width: '88%', borderRadius: '6px', objectFit: 'contain' }}
          />
        </Box>

        {/* Size Section */}
        <Box sx={{ width: '100%' }}>
          <Typography fontWeight={500} fontSize="16px" color="#3F3F3F" mb={1}>
            Size:
          </Typography>
          <img
            src={sizeImage}
            alt="Size"
            style={{ width: '88%', borderRadius: '6px', objectFit: 'contain' }}
          />
        </Box>

        {/* Checkbox Agreement */}
        <Box sx={{ width: '100%' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={e => {
                  setIsChecked(e.target.checked);
                  if (e.target.checked) setShowError(false);
                }}
                sx={{
                  color: '#007BFF',
                  '&.Mui-checked': {
                    color: '#007BFF',
                  },
                }}
              />
            }
            label={
              <Typography
                sx={{ fontSize: '14px', color: '#3F3F3F', textAlign: 'start' }}
              >
                By using the MBF MIS, you consent to the processing of your
                contact information by Maker Bhavan Foundation for marketing &
                communication purposes. Please confirm that you and read and
                understood the instructions above
              </Typography>
            }
            sx={{
              alignItems: 'flex-start',
            }}
          />
        </Box>

        {/* Error Message */}
        {showError && (
          <Alert severity="error" sx={{ width: '100%' }}>
            Please confirm that you have read the instructions before
            proceeding.
          </Alert>
        )}

        {/* Buttons */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            mt: 2,
          }}
        >
          <Typography
            sx={{
              color: '#007BFF',
              fontWeight: 500,
              fontSize: '14px',
              cursor: 'pointer',
              alignSelf: 'center',
            }}
            onClick={() => navigate('/login')}
          >
            &lt; Back
          </Typography>

          <Button
            variant="contained"
            onClick={handleOpenCamera}
            sx={{
              backgroundColor: isChecked ? '#007BFF' : '#ccc',
              color: '#fff',
              fontWeight: 600,
              fontSize: '14px',
              padding: '10px 20px',
              borderRadius: '10px',
              textTransform: 'none',
              boxShadow: 'none',
              cursor: isChecked ? 'pointer' : 'not-allowed',
              '&:hover': {
                backgroundColor: isChecked ? '#B2D7FF' : '#ccc',
                boxShadow: 'none',
              },
            }}
          >
            Open Camera
          </Button>
        </Box>
      </Box>

      {/* Footer */}
      <Logos />
    </Box>
  );
};

export default RegisterInstructions;
